"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSmsActionPicker = void 0;
const lib_event_1 = __importDefault(require("@opsbase/lib-event"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const WorkflowAction_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward/useCallforward"));
const react_markdown_1 = require("@opsbase/react-markdown");
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const PlusIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PlusIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextFieldWithPhoneNumber_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithPhoneNumber/TextFieldWithPhoneNumber"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        '& em': {
            fontStyle: 'italic !important',
            color: 'black !important',
        },
        '& strong': {
            fontStyle: 'normal',
            fontWeight: 'bold',
        },
        '& .ql-toolbar.ql-snow': {
            borderColor: lib_palette_1.default.BorderGrey.main,
        },
        '& .ql-snow .ql-tooltip': {
            whiteSpace: 'normal',
        },
        '& .ql-container': {
            height: 200,
            backgroundColor: '#F4F5F9',
        },
    },
    hiddenVis: {
        visibility: 'hidden',
    },
    addFile: {
        padding: 0,
        marginLeft: 'auto',
        marginRight: 25,
    },
    smallSpinner: {
        size: 24,
    },
    plusIcon: {
        paddingTop: 10,
        color: `${lib_palette_1.default.PastelBlue.main}`,
        '&:hover': {
            color: lib_palette_1.default.error.main,
        },
    },
    deleteIcon: {
        paddingTop: 10,
        color: `${lib_palette_1.default.PastelBlue.main}`,
        '&:hover': {
            color: lib_palette_1.default.error.main,
        },
    },
});
function SendSmsActionPicker(props) {
    const { action, onChangeAction, event, disabled = false } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    let subject = 'issue';
    switch (event) {
        case lib_event_1.default.OP_MISSED:
        case lib_event_1.default.OP_DUE:
        case lib_event_1.default.OP_COMPLETE:
        case lib_event_1.default.OP_LATE:
            subject = 'op';
            break;
        case lib_event_1.default.SENSOR_READING:
            subject = 'asset';
            break;
    }
    const handleBlur = (0, useCallforward_1.default)(i => phoneNumber => {
        {
            if (i > config.sendTo.length - 1) {
                config.sendTo.push(phoneNumber);
            }
            else {
                config.sendTo[i] = phoneNumber;
            }
            action.workflowActionConfig = config;
            onChangeAction(new WorkflowAction_1.default(action));
        }
    }, [config, action, onChangeAction]);
    const handleDelete = (0, react_1.useCallback)(t => {
        const index = config.sendTo.findIndex(s => s === t);
        config.sendTo.splice(index, 1);
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const handleAdd = (0, react_1.useCallback)(() => {
        config.sendTo.push('+44');
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const handleChangeSubject = (0, react_1.useCallback)(() => {
        if (config.event) {
            config.event = undefined;
        }
        else {
            config.event = event;
        }
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction, event]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('sendto')),
            react_1.default.createElement(Vertical_1.default, { gutter: true }, config === null || config === void 0 ? void 0 : config.sendTo.map((s, i) => {
                var _a, _b;
                return (react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', gutter: true, centered: true },
                    react_1.default.createElement(TextFieldWithPhoneNumber_1.default, { disabled: disabled, phoneNumber: s, onBlur: handleBlur(i) }),
                    ((_a = config === null || config === void 0 ? void 0 : config.sendTo) === null || _a === void 0 ? void 0 : _a.length) > 1 && (react_1.default.createElement(IconButton_1.default, { disabled: disabled, onClick: handleDelete, icon: react_1.default.createElement(DeleteIcon_1.default, { classes: {
                                root: myCss.deleteIcon,
                            } }) })),
                    i === ((_b = config === null || config === void 0 ? void 0 : config.sendTo) === null || _b === void 0 ? void 0 : _b.length) - 1 && (react_1.default.createElement(IconButton_1.default, { disabled: disabled, onClick: handleAdd, icon: react_1.default.createElement(PlusIcon_1.default, { classes: {
                                root: myCss.plusIcon,
                            } }) }))));
            }))),
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('message')),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, multiline: true, value: config === null || config === void 0 ? void 0 : config.message, fullWidth: true, onBlur: text => {
                    config.message = text;
                    action.workflowActionConfig = config;
                    onChangeAction(new WorkflowAction_1.default(action));
                } })),
        react_1.default.createElement(Checkbox_1.default, { label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('include-subject-details', {
                subject,
            })), disabled: disabled, color: lib_palette_1.default.secondary, checked: !!(config === null || config === void 0 ? void 0 : config.event), onChange: handleChangeSubject })));
}
exports.SendSmsActionPicker = SendSmsActionPicker;
exports.default = SendSmsActionPicker;
